// React imports
import React from 'react';

// UI – style imports
import { WithStyles, withStyles, useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// local imports
import { styles } from './Fees.style';

function Fees(props: WithStyles<typeof styles>) {
    const { classes } = props;

    const blueBreak = useMediaQuery('(min-width:950px)');
    const mobileDots = useMediaQuery('(min-width:900px)');
    const smallerDots = useMediaQuery('(min-width:510px)');
    const reallySmall = useMediaQuery('(min-width:340px)');

    return (
        <Box className={classes.root}>
            <Box className={classes.topContainer}>
                <Box className={classes.titleContainer}>
                    <p id="top">La única</p>
                    <p className="title">CUENTA</p>
                    <p id="snd" className="title">
                        QUE
                    </p>
                    <p id="td" className="title">
                        NECESITAS
                    </p>
                </Box>
                <p className={classes.topText}>
                    Creamos un servicio financiero que nosotros usamos pensando en ti. Desde tu teléfono móvil tienes
                    acceso a tu dinero de forma segura e inmediata 24/7, puedes enviar y recibir fondos con múltiples
                    opciones.
                </p>
            </Box>

            <Box className={classes.midContainer}>
                <br></br>
                <p id="subtitle">Cuenta de Fondos de Pago Electrónico</p>
                <p className={classes.subtext} style={{ marginBottom: '0px' }}>
                    Cuenca Tecnología Financiera, S.A. de C.V., Institución de Fondos de Pago Electrónico
                </p>
                <p className={classes.subtext}>RECA: 15717-458-044419/01-02183-0926</p>
                <p className="header">TRANSFERENCIAS</p>
                <Box className={classes.comisionContainer}>
                    <Box className={`${classes.comision} blueComision`}>
                        <p className="comisionText">
                            Cuenca a otros bancos ..
                            {reallySmall ? '................' : ''}
                            {smallerDots ? '........' : ''}
                            {mobileDots ? '................................' : ''}
                        </p>
                        <Box className={classes.blueContainer}>
                            <Box
                                className={classes.rightNumber}
                                paddingLeft={0.5}
                                style={{
                                    flexDirection: !blueBreak ? 'column' : 'row',
                                    alignItems: !blueBreak ? 'flex-start' : 'center',
                                }}
                            >
                                <p className="blueText">15</p>
                                <Box paddingLeft={blueBreak ? 0 : 1}>
                                    <p className="endText">transferencias</p>
                                    <p className="endText">mensuales gratis</p>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={`${classes.comision} blueComision`}>
                        <p className="comisionText">
                            1 transferencia diaria ..
                            {reallySmall ? '...................' : ''}
                            {smallerDots ? '.........' : ''}
                            {mobileDots ? '................................' : ''}
                        </p>
                        <Box className={classes.blueContainer}>
                            <Box
                                className={classes.rightNumber}
                                paddingLeft={0.5}
                                style={{
                                    flexDirection: !blueBreak ? 'column' : 'row',
                                    alignItems: !blueBreak ? 'flex-start' : 'center',
                                }}
                            >
                                <p className="blueText">Gratis</p>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={`${classes.comision} blueComision`} textAlign={'left'}>
                        <p className="comisionText">
                            Después de tus 15 transferencias <br /> mensuales, sin contar tu <br />
                            transferencia diaria gratis ..
                            {reallySmall ? '...........' : ''}
                            {smallerDots ? '.........' : ''}
                            {mobileDots ? '................................' : ''}
                        </p>
                        <Box className={classes.rightNumber} marginLeft={0.3}>
                            <p style={{ marginBottom: '2px' }} className="endText">
                                <span className="blueText" style={{ whiteSpace: 'nowrap' }}>
                                    $ 10
                                </span>{' '}
                                <Box marginLeft={1.4}>($8.62 + IVA)</Box>
                            </p>
                        </Box>
                    </Box>
                </Box>

                <p className="header">OTROS</p>
                <Box id="bottom" className={classes.comisionContainer}>
                    <Box className={classes.comision} style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Box marginTop={2}>
                            <p className="comisionText">
                                Manejo de cuenta ...........
                                {reallySmall ? '...............' : ''}
                                {smallerDots ? '.........' : ''}
                                {mobileDots ? '................................' : ''}
                            </p>
                        </Box>
                        <Box className={classes.rightNumber} marginLeft={0.3}>
                            <p style={{ marginBottom: '2px' }} className="endText">
                                <span className="blueText" style={{ whiteSpace: 'nowrap' }}>
                                    $ 50
                                </span>{' '}
                                <Box marginLeft={1.4}>($43.10 + IVA) mensuales por concepto de manejo de cuenta</Box>
                            </p>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default withStyles(styles)(Fees);
